/**
 * Handler for the generate_ab_hero_test AI function (and the matching fast-path).
 *
 * Renders the inline A/B form widget (Source / Variant A / Variant B). The actual
 * two-image generation happens later, when the user fills the form and clicks
 * Generate — see onWidgetAction('ab_hero_generate:…') in NetworksPageV2.vue, which
 * writes the rows into parsedPrompt and dispatches the generation flow.
 */
export const handleGenerateAbHeroTest = async ($message, ctx = {}) => {
  const { dispatch } = ctx;
  let sourceText = '';
  try {
    const args = typeof $message?.function_call?.arguments === 'string'
      ? JSON.parse($message.function_call.arguments)
      : ($message?.function_call?.arguments || {});
    if (args.source_product_reference) sourceText = String(args.source_product_reference);
  } catch (e) { /* no prefill */ }

  const rows = [
    { key: 'source',   label: 'Source',    text: sourceText, image: null },
    // Variant A defaults to "Same as source" — the unified widget's pill state. (POR-13765)
    { key: 'variantA', label: 'Variant A', text: '',         image: null, mode: 'original' },
    { key: 'variantB', label: 'Variant B', text: '',         image: null },
  ];

  await dispatch('addAndSaveMessage', {
    role: 'assistant',
    // The unified v2 widget carries its own "Source" anchor label — no separate chat
    // bubble heading above the card. (POR-13765)
    content: '',
    widgets: [{ type: 'ab_hero', id: 'ab_hero' }],
    // PDP images are square (1:1); default 2000x2000, user-selectable in the widget. (POR-13385)
    _abHeroForm: { rows, generating: false, size: '2000x2000' },
  });
};
